import { render } from "./CprHeader.vue?vue&type=template&id=22efa427"
import script from "./CprHeader.vue?vue&type=script&lang=js"
export * from "./CprHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__